/*
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2025-12-10 09:36:54
 * @LastEditTime: 2026-05-26 14:07:26
 * @LastEditors: hexy 913752270@qq.com
 * @Description  : 
 * @FilePath     : \icps_fb\src\api\internetSales\supplyManagement.js
 */
export const overdueSupplyQueryPage = '/icps/system/sign/cloudSell/overdueSupply/queryPage'
export const overdueSupplyDetailQueryPage = '/icps/system/sign/cloudSell/overdueSupply/queryDetailPage'
export const queryPage1 = '/icps/system/sign/cloudSell/payerUnitManage/queryPage' //付款单位
export const debtSupplyDetailDownload = '/icps/system/sign/cloudSell/debtSupply/exportList'
export const overdueSupplyDownload = '/icps/system/sign/cloudSell/overdueSupply/exportList'
export const processDifferenceDownload = '/icps/system/sign/cloudSell/processDifference/exportList'
export const superGraphDownload = '/icps/system/sign/cloudSell/overDrawSupply/exportList'
export const delegatedControlDownload = '/icps/system/sign/cloudSell/preCommissioning/exportList'
export const exceedContractDownload = '/icps/exceedContract/exportExceedContractProject'
import request from '@/utils/request'
export function overdueSupplyDetailQueryPage2(data) {
    return request({
        url: '/icps/system/sign/cloudSell/overdueSupply/queryDetailPage',
        method: 'post',
        data: data
    })
}
//旧 欠款管控参数查询
// export function querySupplyControlParam(data) {
//     return request({
//         url: '/icps/system/sign/cloudSell/overdueSupply/querySupplyControlParam',
//         method: 'post',
//         data: data
//     })
// }
export function querySupplyControlParam(data) {
    return request({
        url: '/icps/system/sign/cloudSell/supplyControl/querySupplyControlParam',
        method: 'post',
        data: data
    })
}
//旧 欠款管控参数保存
// export function updateSupplyControlParam(data) {
//     return request({
//         url: '/icps/system/sign/cloudSell/overdueSupply/updateSupplyControlParam',
//         method: 'post',
//         data: data
//     })
// }
export function updateSupplyControlParam(data) {
    return request({
        url: '/icps/system/sign/cloudSell/supplyControl/updateSupplyControlParam',
        method: 'post',
        data: data
    })
}
export function updateControl(data) {
    return request({
        url: '/icps/system/sign/cloudSell/overdueSupply/updateControl',
        method: 'post',
        data: data
    })
}
export function examineApprove(data) {
    return request({
        url: '/icps/system/sign/cloudSell/overdueSupply/examineApprove',
        method: 'post',
        data: data
    })
}
export function debtSupplyQueryPage(data) {
    return request({
        url: '/icps/system/sign/cloudSell/debtSupply/queryPage',
        method: 'post',
        data: data
    })
}
export function queryNewDetail(data) {
    return request({
        url: '/icps/system/sign/cloudSell/debtSupply/queryNewDetail',
        method: 'post',
        data: data
    })
}
export function queryHistoryList(data) {
    return request({
        url: '/icps/system/sign/cloudSell/debtSupply/queryHistoryList',
        method: 'post',
        data: data
    })
}
export function applyTerminatedControl(data) {
    return request({
        url: '/icps/system/sign/cloudSell/debtSupply/applyTerminatedControl',
        method: 'post',
        data: data
    })
}
export function approvalCallback(data) {
    return request({
        url: '/icps/system/sign/cloudSell/debtSupply/approvalCallback',
        method: 'post',
        data: data
    })
}
export function overdueSupplyCallback(data) {
    return request({
        url: '/icps/system/sign/cloudSell/overdueSupply/approveCallback',
        method: 'post',
        data: data
    })
}
export function approvalUpdateDetail(data) {
    return request({
        url: '/icps/system/sign/cloudSell/debtSupply/approvalUpdateDetail',
        method: 'post',
        data: data
    })
}
export function queryControlMession(data) {
    return request({
        // url: '/icps/system/sign/cloudSell/debtSupply/queryControlMession',
        url: '/icps/system/sign/cloudSell/supplyControl/queryEngControl',
        method: 'post',
        data: data
    })
}
export function updateData(data) {
    return request({
        url: '/icps/system/sign/cloudSell/overdueSupply/updateData',
        method: 'post',
        data: data
    })
}
export function queryControl(data) {
    return request({
        url: '/icps/system/sign/cloudSell/overdueSupply/queryControl',
        method: 'post',
        data: data
    })
}
export function addCompanyControl(data) {
    return request({
        url: '/icps/system/sign/cloudSell/overdueSupply/addCompanyControl',
        method: 'post',
        data: data
    })
}
export function updateCompanyControl(data) {
    return request({
        url: '/icps/system/sign/cloudSell/overdueSupply/updateCompanyControl',
        method: 'post',
        data: data
    })
}
export function queryHistoryById(data) {
    return request({
        url: '/icps/system/sign/cloudSell/debtSupply/queryHistoryById',
        method: 'post',
        data: data
    })
}
export function updateHistoryById(data) {
    return request({
        url: '/icps/system/sign/cloudSell/debtSupply/updateHistoryById',
        method: 'post',
        data: data
    })
}
export function updateDetatil(data) {
    return request({
        url: '/icps/system/sign/cloudSell/debtSupply/updateDetatil',
        method: 'post',
        data: data
    })
}
// 过程量差管控API 
// 分页获取过程量差节点列表
export function processDifferQuery(data) {
    return request({
        url: '/icps/system/sign/cloudSell/processDifference/queryPage',
        method: 'post',
        data: data
    })
}
//过程量差-确认功能
export function confirmNode(data) {
    return request({
        url: '/icps/system/sign/cloudSell/processDifference/confirmNode',
        method: 'post',
        data: data
    })
}
//过程量差-获取历史记录
export function queryProcessDifferHistory(data) {
    return request({
        url: '/icps/system/sign/cloudSell/processDifference/queryHistory',
        method: 'post',
        data: data
    })
}
//过程量差-提交审批
export function ProcessDifferSubmitApproval(data) {
    return request({
        url: '/icps/system/sign/cloudSell/processDifference/submitApproval',
        method: 'post',
        data: data
    })
}
//过程量差-审批过程中修改数据
export function ProcessDifferUpdateHistory(data) {
    return request({
        url: '/icps/system/sign/cloudSell/processDifference/updateHistory',
        method: 'post',
        data: data
    })
}
//过程量差-修改审批状态
export function ProcessDifferApprovalHandle(data) {
    return request({
        url: '/icps/system/sign/cloudSell/processDifference/approvalHandle',
        method: 'post',
        data: data
    })
}
//过程量差-审批获取数据
export function ProcessDifferHistoryById(data) {
    return request({
        url: '/icps/system/sign/cloudSell/processDifference/queryHistoryById',
        method: 'post',
        data: data
    })
}
//过程量差-保存流程信息
export function ProcessDifferSaveTaskMession(data) {
    return request({
        url: '/icps/system/sign/cloudSell/processDifference/saveTaskMession',
        method: 'post',
        data: data
    })
}
/**
 * 超图算管控
 */
//管控参数查询
// 分页查询
export function superGraphQuery(data) {
    return request({
        url: '/icps/system/sign/cloudSell/overDrawSupply/queryPage',
        method: 'post',
        data: data
    })
}
//获取历史记录
export function querySuperGraphHistory(data) {
    return request({
        url: '/icps/system/sign/cloudSell/overDrawSupply/queryHistory',
        method: 'post',
        data: data
    })
}
//提交审批
export function SuperGraphSubmitApproval(data) {
    return request({
        url: '/icps/system/sign/cloudSell/overDrawSupply/submitApproval',
        method: 'post',
        data: data
    })
}
//审批过程中修改数据
export function SuperGraphUpdateHistory(data) {
    return request({
        url: '/icps/system/sign/cloudSell/overDrawSupply/updateHistory',
        method: 'post',
        data: data
    })
}
//修改审批状态
export function SuperGraphApprovalHandle(data) {
    return request({
        url: '/icps/system/sign/cloudSell/overDrawSupply/approvalHandle',
        method: 'post',
        data: data
    })
}
//审批获取数据
export function SuperGraphHistoryById(data) {
    return request({
        url: '/icps/system/sign/cloudSell/overDrawSupply/queryHistoryById',
        method: 'post',
        data: data
    })
}
//保存流程信息
export function SuperGraphSaveTaskMession(data) {
    return request({
        url: '/icps/system/sign/cloudSell/overDrawSupply/saveTaskMession',
        method: 'post',
        data: data
    })
}
/**
 * 委托管控
 * 
 */
// 分页查询
export function delegatedControlQuery(data) {
    return request({
        url: '/icps/system/sign/cloudSell/preCommissioning/queryPage',
        method: 'post',
        data: data
    })
}
//获取历史记录
export function queryDelegatedHistory(data) {
    return request({
        url: '/icps/system/sign/cloudSell/preCommissioning/queryHistoryList',
        method: 'post',
        data: data
    })
}
//申请解控-获取数据
export function quryApplyData(data) {
    return request({
        url: '/icps/system/sign/cloudSell/preCommissioning/quryApplyData',
        method: 'post',
        data: data
    })
}
//申请解控-查看管控参数
export function queryContrlParam(data) {
    return request({
        url: '/icps/system/sign/cloudSell/supplyControl/queryContrlParam',
        method: 'post',
        data: data
    })
}
//申请解控-验证接口
export function dataVerification(data) {
    return request({
        url: '/icps/system/sign/cloudSell/preCommissioning/dataVerification',
        method: 'post',
        data: data
    })
}
// /申请解控--保存
export function saveDelegatedHistory(data) {
    return request({
        url: '/icps/system/sign/cloudSell/preCommissioning/saveHistory',
        method: 'post',
        data: data
    })
}
// //审批过程中修改数据
export function DelegatedUpdateHistory(data) {
    return request({
        url: '/icps/system/sign/cloudSell/preCommissioning/updateHistotyById',
        method: 'post',
        data: data
    })
}
// //修改审批状态
export function  DelegatedApprovalHandle(data) {
    return request({
        url: '/icps/system/sign/cloudSell/preCommissioning/approvalCallback',
        method: 'post',
        data: data
    })
}
// //审批获取数据
export function DelegatedHistoryById(data) {
    return request({
        url: '/icps/system/sign/cloudSell/preCommissioning/queryHistoryById',
        method: 'post',
        data: data
    })
}
// //保存流程信息
export function DelegatedSaveTaskMession(data) {
    return request({
        url: '/icps/system/sign/cloudSell/preCommissioning/saveProcessMession',
        method: 'post',
        data: data
    })
}
/**
 * 超合同管控
 * 
 */
// 分页查询
export function exceedContractQuery(data) {
    return request({
        url: '/icps/exceedContract/page',
        method: 'post',
        data: data
    })
}
//获取历史记录 -根据id
export function queryExceedContractHistory(id) {
	return request({
		url: `/icps/exceedContract/${id}`,
		method: 'get'
	})
}
// //申请解控-提交审批
export function ExceedContractSubmitApproval(data) {
    return request({
        url: '/icps/exceedContract/applyDecontrol',
        method: 'post',
        data: data
    })
}
// /申请解控--审批页面查询所有数据
export function ExceedContractGetHistoryData(id) {
    return request({
        url: `/icps/exceedContract/history/${id}`,
		method: 'get'
    })
}
// //审批过程中修改数据
export function ExceedContractUpdateHistory(data) {
    return request({
        url: '/icps/exceedContract/alterProcessValue',
        method: 'post',
        data: data
    })
}
// //修改审批状态
export function  ExceedContractApprovalHandle(data) {
    return request({
        url: '/icps/exceedContract/applyDecontrolResult',
        method: 'post',
        data: data
    })
}
